// Страница регистрации нового пользователя: форма с именем, email, паролем и подтверждением.

import { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

export default function RegisterPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const register = useAuthStore((s) => s.register);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2) {
      setError('Пароли не совпадают');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await register(name, email, password);
      navigate(`/register-pending?email=${encodeURIComponent(email)}`);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка регистрации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ewl-auth-page">
      <Container>
        <div className="ewl-auth-card">
          {/* Логотип */}
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: '3.5rem',
                height: '3.5rem',
                borderRadius: '1rem',
                background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                fontSize: '1.5rem',
                boxShadow: '0 4px 16px rgba(79,110,247,0.35)',
              }}
            >
              📖
            </div>
            <h4 className="fw-bold mb-1" style={{ letterSpacing: '-0.01em' }}>
              English We Love
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Создайте новый аккаунт
            </p>
          </div>

          <Card className="border-0" style={{ borderRadius: '1rem', boxShadow: '0 4px 24px rgba(0,0,0,0.09)' }}>
            <Card.Body className="p-4">
              {error && (
                <Alert variant="danger" className="py-2 px-3 mb-3" style={{ fontSize: '0.875rem', borderRadius: '0.5rem' }}>
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                    Имя
                  </Form.Label>
                  <Form.Control
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Иван Иванов"
                    size="lg"
                    required
                    style={{ borderRadius: '0.5rem' }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                    Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    size="lg"
                    required
                    style={{ borderRadius: '0.5rem' }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                    Пароль
                  </Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    size="lg"
                    required
                    style={{ borderRadius: '0.5rem' }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                    Повторите пароль
                  </Form.Label>
                  <Form.Control
                    type="password"
                    value={password2}
                    onChange={(e) => setPassword2(e.target.value)}
                    placeholder="••••••••"
                    size="lg"
                    required
                    isInvalid={password2.length > 0 && password !== password2}
                    style={{ borderRadius: '0.5rem' }}
                  />
                  {password2.length > 0 && password !== password2 && (
                    <Form.Control.Feedback type="invalid">
                      Пароли не совпадают
                    </Form.Control.Feedback>
                  )}
                </Form.Group>

                <Button
                  type="submit"
                  size="lg"
                  className="w-100"
                  disabled={loading}
                  style={{
                    background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                    border: 'none',
                    borderRadius: '0.6rem',
                    fontWeight: 600,
                    letterSpacing: '0.01em',
                  }}
                >
                  {loading ? 'Создаём аккаунт...' : 'Зарегистрироваться'}
                </Button>
              </Form>
            </Card.Body>
          </Card>

          <p className="text-center mt-3 text-muted" style={{ fontSize: '0.875rem' }}>
            Уже есть аккаунт?{' '}
            <Link
              to="/login"
              style={{ color: 'var(--bs-primary)', fontWeight: 500, textDecoration: 'none' }}
            >
              Войти
            </Link>
          </p>
        </div>
      </Container>
    </div>
  );
}
